import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const SuccessAnimation = ({ 
  isVisible, 
  onComplete, 
  campaignProvider, 
  providerId 
}) => {
  const navigate = useNavigate();
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    if (isVisible) {
      // Después de 0.8 segundos, mostrar el contenido (2 segundos antes)
      setTimeout(() => {
        setShowContent(true);
      }, 800);
      
      // No completar automáticamente - esperar acción del usuario
    }
  }, [isVisible]);

  const handleViewCampaign = () => {
    const url = providerId ? `/campaigns/${campaignProvider}/${providerId}` : `/campaigns?platform=${campaignProvider}`;
    navigate(url);
    onComplete(); // Limpiar el estado cuando el usuario toma una acción
  };

  const handleCloseModal = () => {
    navigate('/home');
    onComplete(); // Limpiar el estado cuando el usuario toma una acción
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[40] pointer-events-none">
      {/* Overlay verde que se expande desde el centro */}
      <div 
        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-green-500 rounded-full animate-success-expand"
        style={{
          // Asegurar que cubra toda la pantalla
          minWidth: '200vw',
          minHeight: '200vh',
        }}
      />
      
      {/* Contenido central */}
      {showContent && (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-auto">
          <div className="text-center bg-white rounded-2xl p-8 shadow-2xl max-w-md mx-4 animate-success-content">
            {/* Icono de éxito */}
            <div className="mb-6">
              <CheckCircle className="w-20 h-20 text-green-500 mx-auto animate-success-bounce" />
            </div>
            
            {/* Mensaje principal */}
            <h2 className="text-3xl font-bold text-gray-800 mb-4">
              🎉 Campaña creada con éxito
            </h2>
            
            {/* Mensaje secundario */}
            <p className="text-gray-600 mb-8 text-lg">
              Tu campaña ha sido publicada exitosamente y está lista para generar resultados.
            </p>
            
            {/* Botones de acción */}
            <div className="flex gap-4 justify-center">
              <button
                onClick={handleViewCampaign}
                className="bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-8 rounded-xl transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:scale-105"
              >
                Ver Campaña
              </button>
              <button
                onClick={handleCloseModal}
                className="bg-gray-500 hover:bg-gray-600 text-white font-semibold py-3 px-8 rounded-xl transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:scale-105"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SuccessAnimation;
